import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as Admin from '@store/admin';

import { AdminWorkValidations } from '@components/admin/AdminWorkValidations';

export default connect(
    (state: ApplicationState) => ({
        ...Admin.plainActions,
    }),
    Admin.actionCreators,
)(AdminWorkValidations as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
